(function () {
  const PRODUCT_SEL = '.shopify-section--main-product';
  const SPEC_SEL    = '.shopify-section--specification-table';
  const INFO_HOST   = 'safe-sticky.product-info, .product-info';
  const GALLERY_SEL = 'product-gallery, .product-gallery, .product__media, [data-product-gallery], [data-media-gallery]';
  const INTRO_WITHIN_SPEC = '.section-stack__intro'; // anchor inside spec
  const BREAKPOINT  = 1000;

  const q = (s, r) => (r || document).querySelector(s);

  function getTopOffset() {
    let h = 0;
    const a = document.querySelector('[data-section-type="announcement-bar"], .announcement-bar, #shopify-section-announcement');
    const head = document.querySelector('header.site-header, .header, #shopify-section-header');
    if (a)   h += a.getBoundingClientRect().height || 0;
    if (head) h += head.getBoundingClientRect().height || 0;
    return Math.max(0, Math.round(h)) || 88;
  }

  let active = false, ro = null, scrollHandler = null, resizeHandler = null;

  function disableStickyStyles(inner) {
    if (!inner) return;
    inner.style.position = 'static';
    inner.style.top = '';
    inner.style.left = '';
    inner.style.right = '';
    inner.style.width = '';
    inner.style.transform = '';
    inner.style.zIndex = '';
  }

  function enableSticky() {
    const product = q(PRODUCT_SEL);
    const spec    = q(SPEC_SEL);
    const host    = q(INFO_HOST);
    const gallery = (product && q(GALLERY_SEL, product)) || q(GALLERY_SEL); // ✅ only declared once
    if (!product || !spec || !host) return;

    // inner anchor inside spec
    const intro = spec.querySelector(INTRO_WITHIN_SPEC) || spec;

    // wrap host
    if (!host.parentElement.classList.contains('sticky-rail')) {
      const rail = document.createElement('div');
      rail.className = 'sticky-rail';
      rail.style.position = 'relative';
      rail.style.width = '100%';
      host.parentElement.insertBefore(rail, host);
      rail.appendChild(host);
    }
    const rail = host.parentElement;

    // create inner
    let inner = host.querySelector('.product-info-inner');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'product-info-inner';
      while (host.firstChild) inner.appendChild(host.firstChild);
      host.appendChild(inner);
    }

    inner.style.willChange = 'transform';
    const setRailHeight = () => { rail.style.minHeight = inner.offsetHeight + 'px'; };
    const lockWidthFixed = () => { inner.style.width = rail.getBoundingClientRect().width + 'px'; };
    const clearWidth = () => { inner.style.width = ''; };

    let lastState = 'normal'; // 'normal' | 'fixed' | 'glued' | 'parked'

    const recalc = () => {
      if (window.innerWidth < BREAKPOINT) {
        if (lastState !== 'normal') { disableStickyStyles(inner); lastState = 'normal'; }
        return;
      }

      const topOffset = getTopOffset();
      const startRect = (gallery || product).getBoundingClientRect();
      const introRect = intro.getBoundingClientRect();
      const railRect  = rail.getBoundingClientRect();

      const scrollY  = window.scrollY || window.pageYOffset;
      const startY   = scrollY + startRect.top;    // start sticking
      const endY     = scrollY + introRect.bottom; // end when intro finishes
      const h        = inner.offsetHeight;
      const glueStart = endY - h;
      const yTop     = scrollY + topOffset;
      const railLeft = railRect.left + (window.scrollX || window.pageXOffset);

      // A) before start
      if (yTop < startY) {
        if (lastState !== 'normal') { disableStickyStyles(inner); lastState = 'normal'; }
        setRailHeight();
        return;
      }

      // B) fixed normally
      if (yTop <= glueStart) {
        if (lastState !== 'fixed') { lastState = 'fixed'; inner.style.transition = 'transform 0s'; }
        inner.style.position  = 'fixed';
        inner.style.top       = topOffset + 'px';
        inner.style.left      = railLeft + 'px';
        inner.style.right     = 'auto';
        inner.style.zIndex    = '3';
        inner.style.transform = 'translateY(0)';
        lockWidthFixed();
        setRailHeight();
        return;
      }

      // C) glued — move in sync with scroll
      if (yTop < endY) {
        if (lastState !== 'glued') { lastState = 'glued'; inner.style.transition = 'transform 0s'; }
        const delta = yTop - glueStart;
        inner.style.position  = 'fixed';
        inner.style.top       = topOffset + 'px';
        inner.style.left      = railLeft + 'px';
        inner.style.right     = 'auto';
        inner.style.zIndex    = '3';
        inner.style.transform = `translateY(${-delta}px)`; // parallel motion
        lockWidthFixed();
        setRailHeight();
        return;
      }

      // D) after end → park at bottom
      if (lastState !== 'parked') lastState = 'parked';
      const maxOffset = Math.max(0, endY - startY - h);
      inner.style.position  = 'absolute';
      inner.style.top       = maxOffset + 'px';
      inner.style.left      = '0';
      inner.style.right     = '0';
      inner.style.transform = 'translateY(0)';
      inner.style.zIndex    = '';
      clearWidth();
      setRailHeight();
    };

    // Observe & bind
    ro = new ResizeObserver(() => { setRailHeight(); recalc(); });
    [inner, rail, product, spec, intro, gallery].forEach(el => el && ro.observe(el));

    scrollHandler = () => recalc();
    resizeHandler = () => recalc();
    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', resizeHandler, { passive: true });

    setTimeout(() => { setRailHeight(); recalc(); }, 0);
    active = true;
  }

  function destroySticky() {
    if (ro) ro.disconnect();
    window.removeEventListener('scroll', scrollHandler);
    window.removeEventListener('resize', resizeHandler);
    document.querySelectorAll('.product-info-inner').forEach(disableStickyStyles);
    active = false;
  }

  function initResponsive() {
    if (window.innerWidth >= BREAKPOINT && !active) enableSticky();
    else if (window.innerWidth < BREAKPOINT && active) destroySticky();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') initResponsive();
  else document.addEventListener('DOMContentLoaded', initResponsive, { once: true });

  window.addEventListener('resize', initResponsive, { passive: true });
})();